var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeeBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LOWER_RIGHT",
    d: "M265.846,431.153l111.752-265.878H422.9l19.635,7.185L299.823,512h-33.978V431.153 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LOWER_LEFT",
    d: "M246.153,512h-33.975L69.466,172.46l19.634-7.185h45.302l111.752,265.878 L246.153,512z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UPPER_RIGHT",
    d: "M265.846,323.365l93.629-222.764h45.307L447.063,0h45.306L512,7.186 l-39.263,93.416h22.65l-18.123,43.115H364.006l-98.16,233.542V323.365z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UPPER_LEFT",
    d: "M246.154,377.258l-98.16-233.542H34.733L16.61,100.602h22.653L0,7.186L19.632,0 h45.305l42.284,100.602h45.305l93.629,222.764V377.258z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeeBot);
export default __webpack_public_path__ + "static/media/VeeBot.023437b1fb6c1ff4baa25b99243adf75.svg";
export { ForwardRef as ReactComponent };